import script from "./editMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./editMaterial.vue?vue&type=script&setup=true&lang=js"

import "./editMaterial.vue?vue&type=style&index=0&id=05dd217a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05dd217a"]])

export default __exports__